import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AppConfigProvider } from './context/AppConfigContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import Administration from './pages/Administration';
import PublicSearch from './pages/PublicSearch';
import './App.css';

function App() {
  return (
    <AppConfigProvider>
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public route - Cemetery search */}
            <Route path="/" element={<PublicSearch />} />
            
            {/* Admin login page */}
            <Route path="/admin/login" element={<LoginPage />} />
            
            {/* Protected admin routes */}
            <Route 
              path="/admin/dashboard" 
              element={
                <ProtectedRoute>
                  <Administration />
                </ProtectedRoute>
              } 
            />
            
            {/* Fallback route */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
    </AppConfigProvider>
  );
}

export default App;
